//Funções que estarão sempre disponíveis de forma global no scope do Vue
//Ou seja, sempre que ele renderizar uma página, esta função está presente
//Funções pesadas podem sobrecarregar a página
import Vue from 'vue';

Vue.mixin({
    data(){
        return {
            processSubmitted: false,
            errorsForm: [],
        }
    },
    mounted(){},
    methods: {
        initializeVariables(){
            const el = document.querySelector('#data-page');

            if (el) {
                Object.assign(this.$data, JSON.parse(el.value))
            } else if('dataPage' in window) {
                Object.assign(this.$data, window.dataPage);
            }
        },

        validateEmail(email) {
            var regex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            return regex.test(String(email).toLowerCase());
        },

        isEmailValid(email, classSuccess = '', classError = 'parsley-error'){
            return (email === "") ? "" : (this.validateEmail(email)) ? classSuccess : classError;
        },

        previewToken(id){
            console.log(id)
            var field = document.getElementById(id);

            if (field.type === "password") {
                field.type = "text";
            } else {
                field.type = "password";
            }
        },

        openModalJQuery(modalIdentifier){
            //console.log(modalIdentifier);
            $(modalIdentifier).modal('toggle');
        },

        toggleModalJQuery(modalIdentifier){
            //console.log(modalIdentifier);
            $(modalIdentifier).modal('toggle');
        },

        vueRoute(...args){
            return route(...args);
        },

        imgUrlAlt(event){
            event.target.onerror = null;
            event.target.src = "/assets/images/noImage.png"
        },

        /**
         *
         * @param method "get" | "GET" | "delete" | "DELETE" | "head" | "HEAD" | "options" | "OPTIONS" | "post" | "POST" | "put"
         * @param url {string}
         * @param form {object}
         * @param redirect {string}
         * @param messageSuccess {string}
         * @param headers {object}
         * @returns {Promise<unknown>}
         */
        interceptorRequest(method, url, form, redirect = 'api', messageSuccess = 'Gravado com sucesso!', headers = {}) {
            const _this = this;
            this.$refs?.groupedErrors?.clear();

            this.processSubmitted = true;
            let data;

            if (method === 'GET' || method === 'get') {
                data = {
                    params: form
                }
            } else {
                data = form
            }

            return new Promise((resolve, reject) => {
                this.$axios({
                    method,
                    url,
                    data,
                    headers
                }).then((response) => {
                    resolve(response);

                    setTimeout(() => {
                        if(redirect === 'api' && response.data.hasOwnProperty('redirect')){
                            window.location = response.data.redirect;
                        } else if(redirect === 'history'){
                            console.debug('go history')
                            window.history.go(-1);
                        } else {
                            console.debug('without redirect')
                        }
                    }, 1000);

                    if (messageSuccess) {
                        toastSuccess(messageSuccess)
                    }
                })
                .catch((error) => {
                    _this.processSubmitted = false;
                    // console.debug('form', form)
                    console.error('error in submit global', JSON.stringify(error.response || error));

                    let errors = this.$refs.groupedErrors.set(error);

                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth"
                    })

                    reject(errors)
                })
                .finally(() => {
                    setTimeout(() => {
                        _this.processSubmitted = false;
                    }, 2000)
                })
            })
        },
    }
});
